
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.137 14.08l-1.979-2.02a2.948 2.948 0 00-3.25-.543l-.86-.857a6.648 6.648 0 00-.975-9.032 6.707 6.707 0 00-9.113.324 6.65 6.65 0 00-.326 9.079 6.71 6.71 0 009.066.972l.851.848a2.847 2.847 0 00.507 3.295l2.026 2.018a2.873 2.873 0 004.053 0A2.858 2.858 0 0019 16.123a2.847 2.847 0 00-.863-2.043zm-8.106-4.039a4.796 4.796 0 01-5.207 1.027 4.775 4.775 0 01-2.143-1.754 4.749 4.749 0 010-5.288 4.776 4.776 0 012.143-1.754A4.796 4.796 0 0110.031 3.3a4.761 4.761 0 011.404 3.371 4.747 4.747 0 01-1.404 3.371zm6.758 6.733a.957.957 0 01-1.357 0l-2.026-2.019a.952.952 0 01.31-1.56.96.96 0 011.047.208l2.026 2.019a.95.95 0 010 1.352z","fill":"#000"}})])
          )
        }
      }
    